import * as Tone from 'tone';

export class Arpeggiator {
  constructor(onNoteOn, onNoteOff) {
    this._onNoteOn = onNoteOn;
    this._onNoteOff = onNoteOff;
    this._heldNotes = [];
    this._pattern = 'up';
    this._octaves = 2;
    this._currentIndex = 0;
    this._direction = 1; // 1 = up, -1 = down
    this._lastNote = null;
    this.enabled = false;

    this._loop = new Tone.Loop((time) => {
      this._tick(time);
    }, '8n');
  }

  setEnabled(enabled) {
    this.enabled = enabled;
    if (enabled && this._heldNotes.length > 0) {
      this._currentIndex = 0;
      this._direction = 1;
      Tone.getTransport().start();
      this._loop.start(0);
    } else {
      this._loop.stop();
      if (this._lastNote) {
        this._onNoteOff(this._lastNote);
        this._lastNote = null;
      }
    }
  }

  setPattern(pattern) {
    this._pattern = pattern;
    this._currentIndex = 0;
    this._direction = 1;
  }

  setRate(rate) {
    this._loop.interval = rate;
  }

  setOctaves(octaves) {
    this._octaves = octaves;
  }

  addNote(note) {
    if (!this._heldNotes.includes(note)) {
      this._heldNotes.push(note);
      this._heldNotes.sort((a, b) => Tone.Frequency(a).toMidi() - Tone.Frequency(b).toMidi());
    }
    if (this.enabled && this._heldNotes.length === 1) {
      this._currentIndex = 0;
      this._direction = 1;
      Tone.getTransport().start();
      this._loop.start(0);
    }
  }

  removeNote(note) {
    this._heldNotes = this._heldNotes.filter((n) => n !== note);
    if (this._heldNotes.length === 0) {
      this._loop.stop();
      if (this._lastNote) {
        this._onNoteOff(this._lastNote);
        this._lastNote = null;
      }
    }
  }

  _buildSequence() {
    if (this._heldNotes.length === 0) return [];

    const notes = [];
    for (let oct = 0; oct < this._octaves; oct++) {
      for (const note of this._heldNotes) {
        const midi = Tone.Frequency(note).toMidi() + oct * 12;
        notes.push(Tone.Frequency(midi, 'midi').toNote());
      }
    }
    return notes;
  }

  _tick(time) {
    const seq = this._buildSequence();
    if (seq.length === 0) return;

    // Release previous note
    if (this._lastNote) {
      this._onNoteOff(this._lastNote);
    }

    // Get next note based on pattern
    let note;
    switch (this._pattern) {
      case 'up':
        this._currentIndex = this._currentIndex % seq.length;
        note = seq[this._currentIndex];
        this._currentIndex++;
        break;
      case 'down':
        this._currentIndex = this._currentIndex % seq.length;
        note = seq[seq.length - 1 - this._currentIndex];
        this._currentIndex++;
        break;
      case 'up-down':
        if (seq.length === 1) {
          note = seq[0];
        } else {
          if (this._currentIndex >= seq.length - 1) this._direction = -1;
          if (this._currentIndex <= 0) this._direction = 1;
          note = seq[this._currentIndex];
          this._currentIndex += this._direction;
        }
        break;
      case 'random':
        note = seq[Math.floor(Math.random() * seq.length)];
        break;
      default:
        note = seq[0];
    }

    this._onNoteOn(note, 0.8);
    this._lastNote = note;
  }

  dispose() {
    this._loop.stop();
    this._loop.dispose();
  }
}
